import { createContext, useState } from 'react';

const LanguageContext = createContext({
  language: 'English',
  setLanguage: (lang) => {},
  isLanguageLoading: false,
  fetchLanguagePreference: (id, pathname) => {}
});

export function LanguageContextProvider(props) {
  const [language, setLanguage] = useState('English');
  const [isLanguageLoading, setIsLanguageLoading] = useState(false);
  const [hasLanguageFetched, setHasLanguageFetched] = useState(false);

  function changeLanguageHandler(lang) {
    setLanguage(lang);
  }

  const fetchLanguagePreference = async (id, pathname) => {
    const shouldFetch = ["/resources", "/insights", "/compare", "/assessment", "/progress-milestone", "/results", "/dashboard", "/before-you-start"].some(subPath => pathname.includes(subPath));

    // Only fetch if we haven't fetched before and on eligible routes
    if (shouldFetch && id?.length > 0 && !hasLanguageFetched) {
      setIsLanguageLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URI}/v4/user/assessment/${id}`,
          {
            method: "GET",
            mode: "cors",
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch user assessment');
        }

        const data = await response.json();

        if (data.status === "success" && data.userDetails) {
          const languagePrefDetail = data.userDetails.find(
            (detail) => detail.field === "languagePreference"
          );

          if (languagePrefDetail && languagePrefDetail.value) {
            setLanguage(languagePrefDetail.value);
          } else {
            setLanguage('English');
          }
        } else {
          setLanguage('English');
        }
        setHasLanguageFetched(true);
      } catch (error) {
        console.error('Error fetching language preference:', error);
        setLanguage('English');
        setHasLanguageFetched(true);
      } finally {
        setIsLanguageLoading(false);
      }
    }
  };

  const context = {
    language: language,
    setLanguage: changeLanguageHandler,
    isLanguageLoading: isLanguageLoading,
    fetchLanguagePreference: fetchLanguagePreference
  };

  return (
    <LanguageContext.Provider value={context}>
      {props.children}
    </LanguageContext.Provider>
  );
}

export default LanguageContext;
